import { ColDef } from '@ag-grid-community/core';

import { TableConstants } from '@shared/constants/table.constants';
import { Utils } from '@shared/utils/utils';

import { InvestigatorForecastGridRow } from '../types/investigator-forecast-grid-row';
import { InvestigatorForecastTableContext } from '../types/investigator-forecast-table-context';

export const getInvestigatorForecastTotalAmountColumnDef = (
  ctx: InvestigatorForecastTableContext
): ColDef<InvestigatorForecastGridRow> => {
  return {
    aggFunc: 'sum',
    cellClass: [
      TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT,
      'text-right',
      `budgetCost${ctx.currency}`,
    ],
    field: 'totalAmount',
    headerName: 'Total',
    maxWidth: 200,
    minWidth: 120,
    pinned: 'right',
    resizable: true,
    valueFormatter: (params) => Utils.agCurrencyFormatter(params, ctx.currency),
  };
};
